import { FormSetValueOptions } from '../models/form-set-value-options';

export const DEFAULT_FORM_UPDATE_OPTIONS: FormSetValueOptions = {
  onlySelf: false,
  emitEvent: true
};
